export function toggleConfirmationModal(action) {
  return action;
}
